var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-call-sub-video-component" }, [
    _c(
      "div",
      { staticClass: "room-call-sub-video", class: _vm.subVideoState },
      [
        _c("div", { staticClass: "room-call-sub-video-contents" }, [
          _c("button", {
            staticClass: "room-call-sub-video-button",
            on: { click: _vm.onClickSubVideoControl },
          }),
          _c("div", { staticClass: "sub-video-container" }, [
            _c("video", {
              staticClass: "sub-video",
              attrs: { muted: "", autoplay: "", playsinline: "" },
              domProps: { muted: true },
            }),
            _vm._m(0),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sub-video-cover" }, [
      _c("p", { staticClass: "user-nickname me volume-on" }, [
        _vm._v("Guest49"),
      ]),
      _c("div", { staticClass: "mic-state" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }